module.exports = "/_next/static/images/Hero-a3a7269c5f51a91e2be396b5b4852c1f.webp";